import React from 'react'

const WeddingVideo = () => {
    return (
        <>
 
            <section>
                <div className="wedd pg-wedd-vid m-tp">
                    <div className="container">
                        <div className="row">
                            <div className="ban-wedd">
                                <h2>
                                    Michael <span>&amp; Jessica</span>
                                </h2>
                                <p>
                                    Lakhs of peoples have found their life partner at Wedding
                                    Matrimony!
                                </p>
                                <a href="make-reservation.html" className="cta-dark">
                                    Make reservation
                                </a>
                                <div className="wedd-info">
                                    <ul>
                                        <li>
                                            <i className="fa fa-calendar-o" aria-hidden="true" />
                                            <span>12 June | 9:00 AM</span>
                                        </li>
                                        <li>
                                            <i className="fa fa-map-marker" aria-hidden="true" />
                                            <a href="#!">Direction</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="wedd-vid">
                                    <img src="images/couples/20.jpg" alt="" />
                                    <iframe
                                        src="https://www.youtube.com/embed/P9iKATG9BW4"
                                        title="Wedding marriage: Wedding marriage"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen=""
                                    />
                                    <span
                                        className="vid-play"
                                        data-video="https://www.youtube.com/embed/P9iKATG9BW4?autoplay=1"
                                    >
                                        <i className="fa fa-play" aria-hidden="true" />
                                    </span>
                                </div>
                                <div className="wedd-vid-tree">
                                    <span className="wedd-vid-tre-1" />
                                    <span className="wedd-vid-tre-2" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
         
            <section>
                <div className="wedd-dat wedd-vid-dat">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <div className="save-txt">
                                    <h4>Our story</h4>
                                    <h2>Save the date</h2>
                                </div>
                            </div>
                            <div className="col-md-9">
                                <div className="save-im">
                                    <div className="inn">
                                        <img src="images/couples/9.jpg" alt="" />
                                        <div className="desc">
                                            <span>24, June 2023</span>
                                            <h4>The day we meet</h4>
                                        </div>
                                    </div>
                                    <div className="inn">
                                        <img src="images/couples/7.jpg" alt="" />
                                        <div className="desc">
                                            <span>24, June 2023</span>
                                            <h4>The day we meet</h4>
                                        </div>
                                    </div>
                                    <div className="inn">
                                        <img src="images/couples/6.jpg" alt="" />
                                        <div className="desc">
                                            <span>24, June 2023</span>
                                            <h4>The day we meet</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        
            <section>
                <div className="foot-box wedd-vid-foot">
                    <div className="container">
                        <div className="row">
                            <div className="inn">
                                <ul>
                                    <li>
                                        <div className="foot-inn">
                                            <i className="fa fa-mobile" aria-hidden="true" />
                                            <div>
                                                <span>Phone</span>
                                                <h5>+01 2312 2143</h5>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="foot-inn">
                                            <i className="fa fa-users" aria-hidden="true" />
                                            <div>
                                                <span>Reservation</span>
                                                <h5>Count: 1,000+</h5>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="foot-inn">
                                            <i className="fa fa-map-marker" aria-hidden="true" />
                                            <div>
                                                <span>City</span>
                                                <h5>NewYork</h5>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
 
            <section>
                <div className="wedd-tline">
                    <div className="container">
                        <div className="row">
                            <div className="home-tit">
                                <p>Moments</p>
                                <h2>
                                    <span>Wedding Timeline</span>
                                </h2>
                                <span className="leaf1" />
                                <span className="tit-ani-" />
                            </div>
                            <div className="inn">
                                <ul>
                                    <li>
                                        <div className="tline-inn">
                                            <div
                                                className="tline-im animate animate__animated animate__slower"
                                                data-ani="animate__fadeInUp"
                                            >
                                                <img src="images/icon/wedding-1.png" alt="" />
                                            </div>
                                            <div
                                                className="tline-con animate animate__animated animate__slow"
                                                data-ani="animate__fadeInUp"
                                            >
                                                <h5>Welcome Wedding</h5>
                                                <span>Timing: 7:00 PM</span>
                                                <p>
                                                    Lorem Ipsum is simply dummy text of the printing and
                                                    typesetting industry. Lorem Ipsum has been the industry's
                                                    standard dummy text ever.
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="tline-inn tline-inn-reve">
                                            <div
                                                className="tline-con animate animate__animated animate__slower"
                                                data-ani="animate__fadeInUp"
                                            >
                                                <h5>CEREMONY</h5>
                                                <span>Timing: 7:00 PM</span>
                                                <p>
                                                    Lorem Ipsum is simply dummy text of the printing and
                                                    typesetting industry. Lorem Ipsum has been the industry's
                                                    standard dummy text ever.
                                                </p>
                                            </div>
                                            <div
                                                className="tline-im animate animate__animated animate__slow"
                                                data-ani="animate__fadeInUp"
                                            >
                                                <img src="images/icon/wedding-2.png" alt="" />
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="tline-inn">
                                            <div
                                                className="tline-im animate animate__animated animate__slower"
                                                data-ani="animate__fadeInUp"
                                            >
                                                <img src="images/icon/wedding-4.png" alt="" />
                                            </div>
                                            <div
                                                className="tline-con animate animate__animated animate__slow"
                                                data-ani="animate__fadeInUp"
                                            >
                                                <h5>Dining</h5>
                                                <span>Timing: 7:00 PM</span>
                                                <p>
                                                    Lorem Ipsum is simply dummy text of the printing and
                                                    typesetting industry. Lorem Ipsum has been the industry's
                                                    standard dummy text ever.
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="tline-inn tline-inn-reve">
                                            <div
                                                className="tline-con animate animate__animated animate__slower"
                                                data-ani="animate__fadeInUp"
                                            >
                                                <h5>Photoshoot</h5>
                                                <span>Timing: 7:00 PM</span>
                                                <p>
                                                    Lorem Ipsum is simply dummy text of the printing and
                                                    typesetting industry. Lorem Ipsum has been the industry's
                                                    standard dummy text ever.
                                                </p>
                                            </div>
                                            <div
                                                className="tline-im animate animate__animated animate__slow"
                                                data-ani="animate__fadeInUp"
                                            >
                                                <img src="images/icon/wedding-5.png" alt="" />
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="tline-inn">
                                            <div
                                                className="tline-im animate animate__animated animate__slower"
                                                data-ani="animate__fadeInUp"
                                            >
                                                <img src="images/icon/wedding-6.png" alt="" />
                                            </div>
                                            <div
                                                className="tline-con animate animate__animated animate__slow"
                                                data-ani="animate__fadeInUp"
                                            >
                                                <h5>Music &amp; Party event</h5>
                                                <span>Timing: 7:00 PM</span>
                                                <p>
                                                    Lorem Ipsum is simply dummy text of the printing and
                                                    typesetting industry. Lorem Ipsum has been the industry's
                                                    standard dummy text ever.
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="tline-inn tline-inn-reve">
                                            <div
                                                className="tline-con animate animate__animated animate__slower"
                                                data-ani="animate__fadeInUp"
                                            >
                                                <h5>Party</h5>
                                                <span>Timing: 7:00 PM</span>
                                                <p>
                                                    Lorem Ipsum is simply dummy text of the printing and
                                                    typesetting industry. Lorem Ipsum has been the industry's
                                                    standard dummy text ever.
                                                </p>
                                            </div>
                                            <div
                                                className="tline-im animate animate__animated animate__slow"
                                                data-ani="animate__fadeInUp"
                                            >
                                                <img src="images/icon/wedding-7.png" alt="" />
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="tline-inn">
                                            <div
                                                className="tline-im animate animate__animated animate__slower"
                                                data-ani="animate__fadeInUp"
                                            >
                                                <img src="images/icon/wedding-8.png" alt="" />
                                            </div>
                                            <div
                                                className="tline-con animate animate__animated animate__slow"
                                                data-ani="animate__fadeInUp"
                                            >
                                                <h5>Send off</h5>
                                                <span>Timing: 7:00 PM</span>
                                                <p>
                                                    Lorem Ipsum is simply dummy text of the printing and
                                                    typesetting industry. Lorem Ipsum has been the industry's
                                                    standard dummy text ever.
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
          
            <section>
                <div className="wedd-gall wedd-vid-gall">
                    <div className="">
                        <div className="gall-inn">
                            <div className="home-tit">
                                <p>collections</p>
                                <h2>
                                    <span>Photo gallery</span>
                                </h2>
                                <span className="leaf1" />
                                <span className="tit-ani-" />
                            </div>
                            <div className="col-md-2">
                                <div
                                    className="gal-im animate animate__animated animate__slow"
                                    data-ani="animate__flipInX"
                                >
                                    <img src="images/gallery/1.jpg" className="gal-siz-1" alt="" />
                                    <div className="txt">
                                        <span>Wedding</span>
                                        <h4>Bride &amp; Groom</h4>
                                    </div>
                                </div>
                                <div
                                    className="gal-im animate animate__animated animate__slower"
                                    data-ani="animate__flipInX"
                                >
                                    <img src="images/gallery/9.jpg" className="gal-siz-2" alt="" />
                                    <div className="txt">
                                        <span>Wedding</span>
                                        <h4>Bride &amp; Groom</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div
                                    className="gal-im animate animate__animated animate__slower"
                                    data-ani="animate__flipInX"
                                >
                                    <img src="images/gallery/3.jpg" className="gal-siz-2" alt="" />
                                    <div className="txt">
                                        <span>Wedding</span>
                                        <h4>Bride &amp; Groom</h4>
                                    </div>
                                </div>
                                <div
                                    className="gal-im animate animate__animated animate__slower"
                                    data-ani="animate__flipInX"
                                >
                                    <img src="images/gallery/4.jpg" className="gal-siz-1" alt="" />
                                    <div className="txt">
                                        <span>Wedding</span>
                                        <h4>Bride &amp; Groom</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div
                                    className="gal-im animate animate__animated animate__slower"
                                    data-ani="animate__flipInX"
                                >
                                    <img src="images/gallery/5.jpg" className="gal-siz-1" alt="" />
                                    <div className="txt">
                                        <span>Wedding</span>
                                        <h4>Bride &amp; Groom</h4>
                                    </div>
                                </div>
                                <div
                                    className="gal-im animate animate__animated animate__slower"
                                    data-ani="animate__flipInX"
                                >
                                    <img src="images/gallery/6.jpg" className="gal-siz-2" alt="" />
                                    <div className="txt">
                                        <span>Wedding</span>
                                        <h4>Bride &amp; Groom</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div
                                    className="gal-im animate animate__animated animate__slower"
                                    data-ani="animate__flipInX"
                                >
                                    <img src="images/gallery/7.jpg" className="gal-siz-2" alt="" />
                                    <div className="txt">
                                        <span>Wedding</span>
                                        <h4>Bride &amp; Groom</h4>
                                    </div>
                                </div>
                                <div
                                    className="gal-im animate animate__animated animate__slower"
                                    data-ani="animate__flipInX"
                                >
                                    <img src="images/gallery/8.jpg" className="gal-siz-1" alt="" />
                                    <div className="txt">
                                        <span>Wedding</span>
                                        <h4>Bride &amp; Groom</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div
                                    className="gal-im animate animate__animated animate__slower"
                                    data-ani="animate__flipInX"
                                >
                                    <img src="images/couples/9.jpg" className="gal-siz-2" alt="" />
                                    <div className="txt">
                                        <span>Wedding</span>
                                        <h4>Bride &amp; Groom</h4>
                                    </div>
                                </div>
                                <div
                                    className="gal-im animate animate__animated animate__slower"
                                    data-ani="animate__flipInX"
                                >
                                    <img src="images/couples/11.jpg" className="gal-siz-1" alt="" />
                                    <div className="txt">
                                        <span>Wedding</span>
                                        <h4>Bride &amp; Groom</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END */}
      
        </>

    )
}

export default WeddingVideo